// GET TREATMENTS

import axios from 'axios';
import { Treatment } from 'views/self-service/features/treatment-catalog/types/treatment.type';

// /ewosapi/v1/shrimps/Feed/{globalCompanyId}/brand
export const getTreatments = async (globalCompanyId: string): Promise<Treatment[]> => {
  const res = await axios.get(`/ewosapi/v1/shrimps/Treatment/${globalCompanyId}`);
  return res.data;
};
